"use client";

import type { ReactElement } from "react";
import { DevelopersGrowthChart } from "../developers/_components/developers-growth-chart";
import { CAREERS_CONTENT } from "./careers-content";
import { useCareersLanguage } from "./careers-language-context";

/** "We're just getting started" from the developers funnel: dark chart panel
 * plus copy, flipped to the right via the alt band. */
export function CareersGrowthSection(): ReactElement {
  const { lang } = useCareersLanguage();
  const t = CAREERS_CONTENT[lang].growth;

  return (
    <section
      id="growth"
      className="dvf-section dvf-section-embed dvf-section-alt"
    >
      <div className="dvf-section-inner">
        <div className="dvf-section-grid">
          <div className="dvf-section-media dvf-growth-split-media">
            <DevelopersGrowthChart
              clipId="c2-growth-reveal"
              calloutLabel={t.callout}
            />
          </div>
          <div>
            <h2 className="dvf-section-title">{t.title}</h2>
            <p className="dvf-section-intro">{t.intro}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
